<template>
  <div>
    <v-row class="mt-7" no-gutters align="center" justify="center">
      <v-col cols="12" align="center">
        <v-card height="675" class="containerBorder" flat width="95%">
          <v-row class="pa-5" no-gutters>
            <v-col v-for="(department, index) in $t('departments')" :key="index" class="pa-3" cols="4">
              <v-card height="95" flat color="primary" @click="viewMap(department)">
                <v-row no-gutters class="fill-height" align="center">
                  <v-col cols="12" align="center">
                    <span class="headline white--text">
                      {{ department.departmentName | trimLength }}
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SimpleKeyboard from "@/components/SimpleKeyboard";

export default {
  name: "departments",
  components: {
    SimpleKeyboard,
  },
  data() {
    return {
      tab: 0,
      input: "",
      searchKeyword: "",
      searchBarIcon: "mdi-magnify",
      expand: false,
      cardHeight: 560,
    };
  },
  methods: {
    viewMap(department) {
      console.log('Department : ', department)
      this.$i18n.t("maps").forEach((mapper) => {
        if (mapper.mapName.toLowerCase().trim() === department.departmentMap.toLowerCase().trim()) {
          this.$store.commit("setDepartmentServiceViewer", {
            show: true,
            departmentName: department.departmentName,
            departmentMap: mapper.mapImage,
            services: department.departmentServices.departments.deptCategory
          })
          this.$store.dispatch("avatarSpeak", mapper.speech);
          this.tab = mapper.mapFloor - 1;
        }else{
          console.log('Department not found')
        }
      });
      // this.$store.dispatch("openImageViewer", {
      //   name: name,
      //   url: image,
      //   department: false,
      //   departmentService: []
      // });
      // this.$store.commit("setTouchRequest", {
      //   module: "Departments",
      //   action: "Open Image Dialog",
      //   response: name,
      //   timeStamp: new Date(),
      //   requestType: "Touch",
      // });
      //this.$store.dispatch("avatarSpeak", speech);
    },
  },
  filters: {
    trimLength(val) {
      if (val.length < 90) {
        return val;
      }
      return `${val.substring(0, 70)}...`;
    },
  },
  mounted() {
    console.log('Departments: ', this.$i18n.t('departments'))
  },
};
</script>

<style>
.PDFborder {
  border-style: solid;
  border-width: 2px;
  border-color: #f57c00 !important;
  overflow-y: scroll;
  border-radius: 15px !important;
}
</style>
